/**
 * Feature flag for the Ask Redo new chat UI.
 *
 * Hardcoded `false` while we ship this in incremental PRs without
 * exposing anything to production merchants. Internal testers flip
 * this locally; nothing user-facing on main is wired up to a real
 * audience yet.
 *
 * Follow-up PR will swap the body for a LaunchDarkly team-scoped
 * read. The rest of the app only depends on this hook's shape, so
 * swapping the body is a one-line change.
 *
 * When flag-on:
 *   - Homepage input navigates to `/ask-redo` (new full page)
 *   - Top nav "Ask Redo" button opens the new slide-out
 *   - Legacy `HelpChatGlobal` / `GlobalAI` stay mounted but never
 *     get triggered
 */
export function useAskRedoEnabled(): boolean {
  return false;
}
